import { styled } from '@lichtblick/styled';

import { IconButton } from '../IconButton';

export const Item = styled.div`
  box-sizing: border-box;
  z-index: 4;
  > div {
    > div {
      margin: 0 auto;
    }
  }
`;

export const Container = styled.div`
  width: 80%;
  z-index: 3;

  @media (max-width: 600px) {
    margin: 0 0.5rem;
    width: 100%;
  }

  .slick-next::before,
  .slick-prev::before {
    content: none;
  }
`;

export const MobileArrowButton = styled(IconButton)`
  pointer-events: auto;
  z-index: 10000;

  @media (max-width: 600px) {
    transform: scale(0.8);
  }
`;

export const NextArrowWrapper = styled.div`
  align-items: center;
  bottom: auto;
  display: flex;
  height: 100%;
  justify-content: center;
  pointer-events: auto;
  right: 10px;
  top: 50%;

  @media (max-width: 600px) {
    bottom: -25px;
    height: 60px;
    right: 20px;
    top: auto;
  }
`;

export const PrevArrowWrapper = styled.div`
  align-items: center;
  bottom: auto;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 10px;
  pointer-events: auto;
  top: 50%;

  @media (max-width: 600px) {
    bottom: -25px;
    height: 60px;
    left: 20px;
    top: auto;
  }
`;
